import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import {
  rand,
  randPastDate,
  randFutureDate,
  randRecentDate,
} from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MockServer, MirageServer } from './server.js'
import { pageable, sortable } from './utils.js'
import { consentGiven } from '@/models/communicationPreferences.js'

export type ClientCommunicationPreferenceData =
  SchemaAttributes<'ClientCommunicationPreference'>

export const model = Model as ModelDefinition<ClientCommunicationPreferenceData>

export const factory = Factory.extend<ClientCommunicationPreferenceData>({
  valid_from() {
    return randPastDate().toISOString()
  },
  valid_to() {
    return randFutureDate().toISOString()
  },
  consent_given() {
    return rand(consentGiven)
  },
  privacy_policy_version() {
    return rand([null, '1.0', '2.0'])
  },
  created() {
    return randPastDate().toISOString()
  },
  modified() {
    return randRecentDate().toISOString()
  },
})

export function routes(server: MockServer) {
  server.get(
    '/clients/:id/communication_preferences',
    function (this: MirageServer, schema, request) {
      const sorted = sortable(schema.all('communicationPreference'), request)
      const { data, meta } = pageable(sorted, request)

      return {
        ...this.serialize(data),
        meta: {
          pagination: meta,
        },
      }
    },
  )
}

export function seeds(server: MockServer) {
  server.createList('communicationPreference', 100)
}
